import { defineStore } from 'pinia'
import type { MembersData } from '../../../commons/src/data-validator/dto/validated-data'
import type { AgentDTO, CompanyAdministratorEmailsDto, GroupResponseDTO } from 'commons'

export const useBulkLoadStore = defineStore('bulkLoad', {
  state: () => {
    const savedState = localStorage.getItem('bulkLoadStore')
    if (savedState) {
      try {
        const parsed = JSON.parse(savedState)
        return {
          data: parsed.data || [],
          selectedGroup: parsed.selectedGroup || '',
          publicGroupName: parsed.publicGroupName || '',
          selectedAgent: parsed.selectedAgent || '',
          availableAgents: parsed.availableAgents || [],
          companyAdministrator: parsed.companyAdministrator || {},
          executeMigration: parsed.executeMigration || false,
        }
      } catch (e) {
        console.error('Hubo un error: Error parsing saved bulkLoad store state ', e)
      }
    }

    return {
      data: [] as MembersData[],
      selectedGroup: {} as GroupResponseDTO,
      publicGroupName: '',
      selectedAgent: '',
      availableAgents: [] as AgentDTO[],
      companyAdministrator: {} as CompanyAdministratorEmailsDto,
      executeMigration: false,
    }
  },
  actions: {
    setData(newData: MembersData[]) {
      this.data = newData
      this.saveState()
    },
    setSelectedGroup(group: GroupResponseDTO) {
      this.selectedGroup = group
      this.saveState()
    },
    setPublicGroupName(name: string) {
      this.publicGroupName = name
      this.saveState()
    },
    setSelectedAgent(agent: string) {
      this.selectedAgent = agent
      this.saveState()
    },
    setAvailableAgents(agents: AgentDTO[]) {
      this.availableAgents = agents
      this.saveState()
    },
    setCompanyAdministrators(companyAdministrator: CompanyAdministratorEmailsDto) {
      this.companyAdministrator = companyAdministrator
      this.saveState()
    },
    setExecuteMigration(value: boolean) {
      this.executeMigration = value
      this.saveState()
    },
    saveState() {
      localStorage.setItem(
        'bulkLoadStore',
        JSON.stringify({
          data: this.data,
          selectedGroup: this.selectedGroup,
          publicGroupName: this.publicGroupName,
          selectedAgent: this.selectedAgent,
        }),
      )
    },
    clearState() {
      localStorage.removeItem('bulkLoadStore')
      this.data = []
      this.selectedGroup = {} as GroupResponseDTO
      this.publicGroupName = ''
      this.selectedAgent = ''
    },
  },
})
